export default "__VITE_ASSET__BuWXfleI__"